export enum ActionType {
    Approved = "Approved",
    Rejected = "Rejected",
    Deferred = "Deferred",
    Feedback = "Feedback",
    Submitted = "Submitted",
    Initiated = "Initiated",
    Review = "Review",
    ApprovalInProgress = "ApprovalInProgress",
    RenewalAccepted = "Renewal Accepted",
    RenewalRejected = "Renewal Rejected",
    RenewalResent = "Renewal Resent",
    DocumentSigningVendor = "DocumentSigningVendor",
    DocumentSigningReviewer = "DocumentSigningReviewer",
    InExecutiveReview = "InExecutiveReview",
}
